import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Message from "../LoadingError/Error";
import Loading from "../LoadingError/Loading";
import {
  listMyOrders,
  OrderCancellationRequest,
} from "../../Redux/Actions/OrderActions";
import Toast from "../LoadingError/Toast";
import { toast } from "react-toastify";
import { DEFAULT_CURRENCY } from "../../Redux/Constants/GlobalConstant";
import ReactPaginate from "react-paginate";

const ToastObjects = {
  pauseOnFocusLoss: false,
  draggable: false,
  pauseOnHover: false,
  autoClose: 1000,
};

const getStatusBadge = (order) => {
  if (order.isCanceled) {
    return <span className="order-status-badge badge-cancelled">✕ Cancelled</span>;
  }
  if (order.isDelivered) {
    return <span className="order-status-badge badge-delivered">✓ Delivered</span>;
  }
  const rawStatus = order?.status?.[order?.status.length - 1]?.status || "";
  const label = rawStatus.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  return <span className="order-status-badge badge-placed">📦 {label}</span>;
};

const getPaymentBadge = (order) => {
  if (order.isPaid) {
    return <span className="order-status-badge badge-paid">✓ Paid</span>;
  }
  if (order.isCOD) {
    return <span className="order-status-badge badge-placed">💵 COD</span>;
  }
  return <span className="order-status-badge badge-unpaid">✕ Unpaid</span>;
};

const getCardClass = (order) => {
  if (order.isCanceled) return "order-card cancelled";
  if (order.isDelivered) return "order-card delivered";
  if (order.isPaid || order.isCOD) return "order-card paid";
  return "order-card unpaid";
};

const Orders = () => {
  const [selectedOption, setSelectedOption] = useState(0);
  const dispatch = useDispatch();

  const orderListMy = useSelector((state) => state.orderListMy);
  const { loading, error, orders } = orderListMy;

  const handleChange = (e, orderId) => {
    if (parseInt(e.target.value) === 2) {
      if (window.confirm("Are you sure want to Cancel?")) {
        dispatch(OrderCancellationRequest(orderId));
        toast.success("Order Cancel Request", ToastObjects);
      } else {
        setSelectedOption(0);
      }
    }
  };

  const handlePageClick = ({ selected }) => {
    // react-paginate uses 0-based indexing (0 for page 1),
    // but the backend API expects 1-based indexing (1 for page 1).
    dispatch(listMyOrders(selected + 1));
  };

  useEffect(() => {
    dispatch(listMyOrders(1));
  }, [dispatch]);

  return (
    <div>
      <Toast />
      {loading ? (
        <Loading />
      ) : error ? (
        <Message variant="alert-danger">{error}</Message>
      ) : (
        <>
          {!orders?.result || orders.result.length === 0 ? (
            <div className="orders-empty">
              <div className="orders-empty-icon">🛒</div>
              <div className="orders-empty-title">No Orders Yet</div>
              <div className="orders-empty-sub">
                You haven't placed any orders. Start shopping now!
              </div>
              <Link to="/" className="orders-empty-btn">
                Start Shopping
              </Link>
            </div>
          ) : (
            <>
              {/* Order Cards */}
              <div className="order-cards-list">
                {orders.result.map((order) => (
                  <div key={order._id} className={getCardClass(order)}>
                    {/* Icon */}
                    <div className="order-card-icon">🛍️</div>

                    {/* Info */}
                    <div className="order-card-info">
                      <a
                        href={`/order/${order._id}`}
                        className="order-card-id"
                        title={order._id}
                      >
                        #{order._id.slice(-12).toUpperCase()}
                      </a>
                      <div className="order-card-date">
                        🕐&nbsp;
                        {order.isPaid
                          ? moment(order.paidAt).calendar()
                          : moment(order.createdAt).calendar()}
                      </div>
                    </div>

                    {/* Status + Payment row */}
                    <div style={{ display: "flex", flexDirection: "column", gap: "6px", alignItems: "center" }}>
                      {getPaymentBadge(order)}
                      {getStatusBadge(order)}
                    </div>

                    {/* Price + Action */}
                    <div className="order-card-meta">
                      <div className="order-card-price">
                        {DEFAULT_CURRENCY} {Number(order.totalPrice).toFixed(2)}
                      </div>

                      {order.isCanceled && order.isPaid && !order.isDelivered ? (
                        <span className="order-status-badge badge-refund">↩ Refund Requested</span>
                      ) : !order.isCanceled && !order.isDelivered ? (
                        <select
                          className="order-action-select"
                          onChange={(e) => handleChange(e, order._id)}
                          defaultValue={selectedOption}
                        >
                          <option value={0}>Actions…</option>
                          <option value={2}>Cancel Order</option>
                        </select>
                      ) : null}
                    </div>
                  </div>
                ))}
              </div>

              {/* Pagination */}
              <ReactPaginate
                pageCount={orders?.pages + 1}
                nextLabel="›"
                onPageChange={handlePageClick}
                pageRangeDisplayed={1}
                marginPagesDisplayed={2}
                previousLabel="‹"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakLabel="…"
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination profile-pagination"
                activeClassName="active"
                renderOnZeroPageCount={null}
                forcePage={orders?.page ? orders.page - 1 : 0}
              />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default Orders;
